import { computed, george, helpers, observable, observer, React, RouteComponentProps } from "aaa";
import { FeatureRoutes } from "components/app/AppRoutes";
import { TopBackgroundColor } from "components/util/TopBackgroundColor";
import * as gitVersion from "gitVersion";
import { parse, stringify } from "query-string";
import { Link } from "react-router-dom";
import authStore from "stores/AuthStore";
import { pushRoute } from "stores/RouterFunctions";

/**
 * Client ID Description:
 * INT824BB (Store App client ID)
 * INT82482 (Store Web client ID)
 * C023449O (Non Sales App clientID)
 * C02345N6 (Non Sales Web clientID)
 */

const CLIENT_IDS = [
    "georgeclient",
    "transactionapp",
    "C02063ZZ",
    "C023449O", // Hybrid pages App
    "INT824BB", // Shop pages App
    "C02345N6", // ClientID Non Store Hybrid pages Web, George Mile and More
    "INTGB5J7", // George Business (Web?)
    "INTGB808", // George Business (App?)
];

@observer
export default class Component extends React.Component<RouteComponentProps<{}>, {}> {
    @observable private _clientId = "georgeclient";
    @observable private _manualClientId = "";
    @observable private _bspOptionsContractId = "";
    @observable private _savingsOptionsAccountId = "";
    @computed get clientId() {
        return this._manualClientId.length > 0 ? this._manualClientId : this._clientId;
    }

    getRedirectUri() {
        const url = window.location.href.split("?")[0];
        const queryParams = parse(decodeURIComponent(window.location.search));

        switch (this.clientId) {
            case "INTGB5J7":
                return `${url}?${stringify({ ...queryParams, channel: "27" })}`;
            case "INTGB808":
                return `${url}?${stringify({ ...queryParams, channel: "28" })}`;
            default:
                return `${url}?${stringify({ ...queryParams, channel: "" })}`;
        }
    }

    componentDidMount() {
        if (this.isAuthorized()) {
            pushRoute("/feature-tests");
        }
    }

    componentDidUpdate() {
        if (this.isAuthorized()) {
            pushRoute("/feature-tests");
        }
    }

    isAuthorized() {
        return authStore.accessToken && helpers.isUid(authStore.accessToken);
    }

    render() {
        // const pathComponents = window.location.href.split("#");

        // debug.log("### root", pathComponents[0]);
        return (
            <div
                className="theme-landing-background-color"
                style={{ minHeight: "100vh" }}
            >
                <TopBackgroundColor color="silver" />
                <div style={{ fontSize: 16, background: "silver", padding: 10 }}>
                    branch: {gitVersion.GIT_BRANCH} - version: {gitVersion.GIT_VERSION}
                </div>

                <div style={{ padding: 20, fontSize: 20 }}>
                    {!this.isAuthorized() && (
                        <div>
                            <h3 className="theme-title-color">ClientID wählen</h3>
                            <george.DropDown
                                value={this._clientId}
                                onChange={(event: any, index: any, value: any) => {
                                    this._clientId = value;
                                }}
                                items={CLIENT_IDS.map(id => ({ value: id, label: id }))}
                            />

                            <br />
                            <small>Optional: manuelle Eingabe</small>
                            <george.TextField
                                id="clientId"
                                value={this._manualClientId}
                                onChange={(event, value) => this._manualClientId = value}
                                hintText="ClientID"
                            />

                            <h3 className="theme-title-color">Login</h3>
                            <a
                                className="theme-paragraph-color"
                                href={`https://login.fat.sparkasse.at/sts/oauth/authorize?response_type=token&client_id=${this.clientId}&redirect_uri=${this.getRedirectUri()}`}
                            >
                                Login mit ClientID "{this.clientId}"
                            </a>
                            <div style={{ borderBottom: "1px solid silver", margin: "64px 0" }} />
                            <div>
                                <h4 className="theme-title-color">Feature: BSP Options</h4>
                                <small>Parameter <i>contractId</i></small>
                                <george.TextField
                                    id="contractId"
                                    value={this._bspOptionsContractId}
                                    onChange={(event, value) => this._bspOptionsContractId = value}
                                    hintText="contractId"
                                />
                                <Link
                                    className="theme-paragraph-color"
                                    to={`${FeatureRoutes.BSP_OPTIONS}?clientId=georgeclient&contractId=${this._bspOptionsContractId}`}
                                    style={{ display: "block", marginTop: 24 }}
                                >
                                    Bauspar Optionen für Vertrag "{this._bspOptionsContractId || "keine Eingabe"}"
                                </Link>
                            </div>
                            <div>
                                <h4 className="theme-title-color">Feature: no-auth-test URL</h4>
                                <Link
                                    className="theme-paragraph-color"
                                    to={`${FeatureRoutes.HANDOVER_URL_TEST}`}
                                    style={{ display: "block", marginTop: 24 }}
                                >
                                    "Handover URL Test - URL (e.g. George FIT - no login required)"
                                </Link>
                            </div>
                            <div style={{ borderBottom: "1px solid silver", margin: "64px 0" }} />
                            <div>
                                <h4 className="theme-title-color">Feature: Savings Options</h4>
                                <small>Parameter <i>accountId</i></small>
                                <george.TextField
                                    id="accountId"
                                    value={this._savingsOptionsAccountId}
                                    onChange={(event, value) => this._savingsOptionsAccountId = value}
                                    hintText="accountId"
                                />
                                <Link
                                    className="theme-paragraph-color"
                                    to={`${FeatureRoutes.SAVINGS_OPTIONS}?clientId=georgeclient&accountId=${this._savingsOptionsAccountId}`}
                                    style={{ display: "block", marginTop: 24 }}
                                >
                                    Sparkonto Optionen für Account "{this._savingsOptionsAccountId || "keine Eingabe"}"
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/test/FeatureTestsLogin.tsx